import { Outlet } from "react-router-dom";
import { TabWithOutlet } from "@/components/tab";
import { Typography } from "@altimateai/lego";

const BiReportsContainer = () => {
  const tabs = [
    { label: "Dashboards", path: "/bi-reports/dashboards" },
    { label: "Users", path: "/bi-reports/users" },
  ];

  return (
    <div>
      <Typography variant="page-heading" className={"al-mb-4"}>
        Insights
      </Typography>
      <TabWithOutlet tabs={tabs} />
      <Outlet />
    </div>
  );
};

export default BiReportsContainer;
